import axios from 'axios'
import auth from '../auth'
import { logException } from '@/services/AppInsights'

// Set config defaults when creating the instance
export const http = axios.create({
  timeout: 200000,
  baseURL: process.env.VUE_APP_API,
  transformResponse: function(data, headers) {
    const contentType: string = (headers as any)['content-type'] || ''
    if (contentType.includes('application/json')) {
      // Failsafe: don't try and parse huge API responses. Ref: 1000000 === 1 MB
      if (data.length > 10000000) {
        // console.error('Unable to parse API response')
        throw new Error('Unable to parse API response')
      }
      let parsedData = JSON.parse(data)
      if (parsedData.hasOwnProperty('error')) {
        let errorData = parsedData.error
        let errorDetailedDescription = ''
        let errorDescriptionKeyword = ''
        let errorStartIndex = -1
        let errorEndIndex = -1
        let errorMessage = ''
        let exceptionType = ''

        switch (true) {
          case errorData.includes('Unable to deserialize token'): {
            errorDescriptionKeyword = 'error_description'
            errorStartIndex = errorData.indexOf(errorDescriptionKeyword)
            exceptionType = 'SAP Access Error'

            if (errorStartIndex !== -1) {
              errorEndIndex = errorData.indexOf('. ', errorStartIndex)
              errorMessage = errorMessageExtraction(
                errorData,
                errorDescriptionKeyword,
                errorStartIndex,
                errorEndIndex,
              )
              errorDetailedDescription = 'User does not have SAP access'
            }
            break
          }

          case errorData.includes('One or more errors occurred'): {
            errorDescriptionKeyword = 'HTTPStatusDescription'
            errorStartIndex = errorData.indexOf(errorDescriptionKeyword)
            exceptionType = 'SAP API Error'

            if (errorStartIndex !== -1) {
              errorEndIndex = errorData.indexOf(', ', errorStartIndex)
              errorMessage = errorMessageExtraction(
                errorData,
                errorDescriptionKeyword,
                errorStartIndex,
                errorEndIndex,
              )
              errorDetailedDescription = 'Issue with BOOMI API Service'
            }
            break
          }

          default:
            exceptionType = 'Generic Error'
            errorDetailedDescription = 'Some problem encountered in VHUB APIs'
            break
        }
        logException(
          exceptionType,
          errorMessage.length > 0 ? errorMessage : errorData,
          errorDetailedDescription,
        )
      }

      return parsedData
    }
    return data
  },
})

http.interceptors.request.use(
  async config => {
    const token = await auth.acquireToken(process.env.VUE_APP_CLIENTID)
    // Set default request headers for every request
    config.headers['Content-Type'] = 'application/json'
    config.headers.Authorization = 'Bearer ' + token
    return config
  },
  error => {
    Promise.reject(error)
  },
)

function errorMessageExtraction(
  errorData: any,
  errorDescriptionKeyword: string,
  errorStartIndex: number,
  errorEndIndex: number,
): string {
  return errorData.substring(errorStartIndex + errorDescriptionKeyword.length + 3, errorEndIndex)
}
